import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { YIELD_SCHEDULER_ROUTE_PATHS } from './config';

export const YIELD_SCHEDULER_ROUTES: TApplicationRoute[] = [
  {
    id: 'yield-scheduler',
    path: YIELD_SCHEDULER_ROUTE_PATHS.yieldScheduler,
    component: lazy(() => import('./pages/yield-scheduler-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['yield-scheduler'] },
    menu: {
      title: 'pages.yieldScheduler.title',
    },
  },
];
